<template>
  <div>
    <div v-if="$can('read', 'current-plan')" class="mt-auto p-5 pr-16">
      <div
        class="text-base font-semibold"
        v-html="$t('navigation.usage.title', { plan: userPlan?.nameInCapitalLetters })" />
      <div v-if="accountSubscriptionIsDemo" class="flex-col gap-4 w-100 flex justify-between">
        <div class="text-xs text-black/80">{{ $t("navigation.usage.mx.caption") }}</div>
        <UpgradePlanButton size="default" :class="`rounded-lg max-w-44`" />
      </div>
      <QrsProgressBar v-else class="flex-col gap-4" flex-direction="col" />
    </div>
    <ap-divider class="m-0" />
    <TheMainLayoutSiderFooterUserAvatar />
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia"
import TheMainLayoutSiderFooterUserAvatar from "./TheMainLayoutSiderFooterUserAvatar.vue"
import QrsProgressBar from "@/components/ProgressBars/QrsProgressBar.vue"
import { useUserAccountsStore } from "../../stores/userAccounts"
import UpgradePlanButton from "../../components/UpgradePlan/UpgradePlanButton.vue"
import useAccountChecker from "@/composables/accountChecker"

const { userPlan } = storeToRefs(useUserAccountsStore())
const { accountSubscriptionIsDemo } = useAccountChecker()
</script>
